module.exports = "<app-menu></app-menu>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/sidebar/sidebar.component.html
// module id = ./src/app/core/sidebar/sidebar.component.html
// module chunks = main